const baseUrl = 'https://kandianshare.html5.qq.com/api/vision';
export const config = {
    reportUrl: `${baseUrl}/collect`,
    reportSpeedUrl: `${baseUrl}/collectSpeed`
};
//# sourceMappingURL=config.js.map